import { Action } from 'redux'
import { IProfile } from '../../../models/Object'
import { IRequestValues } from '../../../models/Object/saveProfile'
import { UserProfileActions } from '../../../reducers/userObject/actionNames'

const requestUpdateLogo = (data: IRequestValues): IRequestUpdateLogo => ({
  data,
  type: UserProfileActions.RequestUpdateUserProfileLogo,
})

export interface IRequestUpdateLogo
  extends Action<UserProfileActions.RequestUpdateUserProfileLogo> {
  type: UserProfileActions.RequestUpdateUserProfileLogo
  data: IRequestValues
}

const requestUpdateLogoAccepted = (
  data: IProfile,
): IRequestUpdateLogoAccepted => ({
  profile: data,
  type: UserProfileActions.RequestUpdateUserProfileLogoAccepted,
})

export interface IRequestUpdateLogoAccepted
  extends Action<UserProfileActions.RequestUpdateUserProfileLogoAccepted> {
  profile: IProfile
}

const requestUpdateLogoRejected = () => ({
  type: UserProfileActions.RequestUpdateUserProfileLogoRejected,
})

export interface IRequestUpdateLogoRejected
  extends Action<UserProfileActions.RequestUpdateUserProfileLogoRejected> {
  type: UserProfileActions.RequestUpdateUserProfileLogoRejected
}

export {
  requestUpdateLogoAccepted,
  requestUpdateLogo,
  requestUpdateLogoRejected,
}
